/* ============================================================
   CUTLERY CRISIS — Theme JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ============================================================
  // FIXED HEADER — offset main content to prevent overlap
  // ============================================================
  const header = document.querySelector('.site-header');
  const mainContent = document.querySelector('#main-content');

  function setHeaderOffset() {
    if (header && mainContent) {
      mainContent.style.paddingTop = header.offsetHeight + 'px';
    }
  }

  setHeaderOffset();
  window.addEventListener('resize', setHeaderOffset, { passive: true });

  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ============================================================
  // MOBILE NAV
  // ============================================================
  const mobileToggle = document.querySelector('.header__mobile-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const navOverlay = document.querySelector('.nav-overlay');
  const mobileClose = document.querySelector('.mobile-nav__close');

  const openMobileNav = () => {
    mobileNav?.classList.add('open');
    navOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  const closeMobileNav = () => {
    mobileNav?.classList.remove('open');
    navOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  };

  mobileToggle?.addEventListener('click', openMobileNav);
  mobileClose?.addEventListener('click', closeMobileNav);
  navOverlay?.addEventListener('click', closeMobileNav);

  // ============================================================
  // CART DRAWER
  // ============================================================
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  const cartClose = document.querySelector('.cart-drawer__close');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');

  const openCart = () => {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  };

  const closeCart = () => {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  };

  cartTriggers.forEach(t => t.addEventListener('click', openCart));
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  // Refresh cart contents
  async function refreshCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      renderCartItems(cart);
    } catch (e) {
      console.warn('Could not fetch cart', e);
    }
  }

  function renderCartItems(cart) {
    const itemsContainer = document.querySelector('.cart-drawer__items');
    const subtotalEl = document.querySelector('.cart-subtotal__amount');
    const countEl = document.querySelector('.cart-count');

    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    // Free UK shipping nudge (threshold matches templates/cart.liquid)
    const shippingEl = document.querySelector('.cart-drawer__shipping');
    if (shippingEl) {
      const threshold = 5000;
      if (cart.item_count === 0) {
        shippingEl.textContent = '';
      } else if (cart.total_price < threshold) {
        shippingEl.innerHTML = 'You\'re <strong>' + formatMoney(threshold - cart.total_price) + '</strong> away from free UK shipping.';
      } else {
        shippingEl.textContent = 'You\'ve got free UK shipping on this order.';
      }
    }

    if (!itemsContainer) return;

    if (cart.items.length === 0) {
      itemsContainer.innerHTML = `
        <div style="text-align:center; padding: 3rem 0; color: var(--quiet-grey);">
          <p style="font-family: var(--font-display); font-size: 1.2rem; margin-bottom: 0.5rem;">Nothing here yet.</p>
          <p style="font-style: italic; font-size: 0.85rem;">Much like our spoon reserves.</p>
        </div>`;
      return;
    }

    itemsContainer.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__image">
          <img src="${item.image}" alt="${item.title}" loading="lazy">
        </div>
        <div class="cart-item__details">
          <div class="cart-item__title">${item.product_title}</div>
          <div class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div class="cart-item__price-row">
            <div class="cart-item__qty">
              <button class="qty-decrease" data-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
              <span>${item.quantity}</span>
              <button class="qty-increase" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
            </div>
            <div class="price">${formatMoney(item.final_line_price)}</div>
          </div>
          <button class="cart-item__remove" data-key="${item.key}">Remove</button>
        </div>
      </div>
    `).join('');

    // Bind qty / remove buttons
    itemsContainer.querySelectorAll('.qty-decrease, .qty-increase').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty);
        await updateCartItem(key, qty);
      });
    });

    itemsContainer.querySelectorAll('.cart-item__remove').forEach(btn => {
      btn.addEventListener('click', async () => {
        await updateCartItem(btn.dataset.key, 0);
      });
    });
  }

  async function updateCartItem(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      await refreshCart();
    } catch (e) {
      console.warn('Cart update failed', e);
    }
  }

  // ============================================================
  // ADD TO CART
  // ============================================================
  const addToCartForms = document.querySelectorAll('[data-add-to-cart-form]');

  addToCartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart-btn]');

      // A size must be picked: never fall back to the first size
      const sizeSelector = form.querySelector('.size-selector');
      if (sizeSelector && !sizeSelector.querySelector('.size-option.selected')) {
        const err = form.querySelector('[data-size-error]');
        if (err) err.hidden = false;
        sizeSelector.querySelector('.size-option:not(.sold-out)')?.focus();
        return;
      }
      const originalText = btn.innerHTML;

      btn.innerHTML = '<span class="loading-spinner"></span>';
      btn.disabled = true;

      const formData = new FormData(form);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: parseInt(formData.get('quantity') || 1)
          })
        });

        if (response.ok) {
          showNotification('Added to cart.');
          openCart();
        } else {
          showNotification('Could not add to cart. Try again.');
        }
      } catch (e) {
        showNotification('Something went wrong.');
      } finally {
        btn.innerHTML = originalText;
        btn.disabled = false;
      }
    });
  });

  // ============================================================
  // VARIANT SELECTOR — colour swatches + size buttons
  // ============================================================
  const variants = window.ccProduct?.variants || [];
  const colorPosition = window.ccProduct?.colorPosition || 0;
  const colorKey = colorPosition ? 'option' + colorPosition : null;

  // Colour name → hex lookup
  const COLOR_HEX = {
    'white': '#FFFFFF', 'black': '#1A1A1A', 'sand': '#C4B49A',
    'natural': '#E8DFC8', 'navy': '#1F3A6E', 'red': '#B03A2E',
    'blue': '#2471A3', 'green': '#1E8449', 'forest': '#1A5276',
    'forest green': '#1A5276', 'pink': '#D98880', 'purple': '#7D3C98',
    'yellow': '#D4AC0D', 'orange': '#CA6F1E', 'brown': '#7D6608',
    'cream': '#FFF8E7', 'slate': '#708090', 'grey': '#9B9B9B',
    'gray': '#9B9B9B', 'sport grey': '#A0A0A0', 'ash': '#B8B8B8',
    'heather': '#A0A0A0', 'athletic heather': '#A0A0A0',
    'charcoal': '#424949', 'burgundy': '#6B1F2A', 'maroon': '#7B241C',
    'khaki': '#B7950B', 'stone': '#C2B49A', 'bone': '#E8D5B0',
    'light blue': '#A8C8E8', 'sky blue': '#B8D8EE',
    'cornsilk': '#FFF8DC', 'daisy': '#F5C518',
  };

  function getSwatchHex(name) {
    const key = name.toLowerCase();
    if (COLOR_HEX[key]) return COLOR_HEX[key];
    for (const [k, v] of Object.entries(COLOR_HEX)) {
      if (key.includes(k) || k.includes(key)) return v;
    }
    return '#CCCCCC';
  }

  // Build colour → first variant image map
  const colorImages = {};
  if (colorKey) {
    variants.forEach(v => {
      const col = v[colorKey];
      if (col && !colorImages[col] && v.featured_image) {
        colorImages[col] = v.featured_image.src;
      }
    });
  }

  // Apply dot colours
  document.querySelectorAll('.color-swatch').forEach(swatch => {
    const hex = getSwatchHex(swatch.dataset.color || '');
    const dot = swatch.querySelector('.color-swatch__dot');
    if (!dot) return;
    dot.style.background = hex;
    if (['#FFFFFF','#FFF8E7','#E8DFC8','#B8B8B8','#E8D5B0','#A8C8E8','#B8D8EE','#FFF8DC'].includes(hex)) {
      dot.style.boxShadow = 'inset 0 0 0 1px rgba(0,0,0,0.18)';
    }
  });

  function selectedColor() {
    return document.querySelector('.color-swatch.selected')?.dataset.color;
  }

  function selectedSize() {
    return document.querySelector('.size-option.selected')?.textContent?.trim();
  }

  function setOptionDisplay(group, text) {
    const display = group?.parentElement?.querySelector('.selected-option-display');
    if (display) display.textContent = text || '';
  }

  // Exact match only: the chosen colour and size, in stock. No fallback to another size.
  function findVariant() {
    const color = selectedColor();
    const size = selectedSize();
    return variants.find(v => {
      const cm = !colorKey || !color || v[colorKey] === color;
      const sm = !size || [v.option1, v.option2, v.option3].includes(size);
      return cm && sm && v.available;
    });
  }

  function applyVariant(v) {
    if (!v) return;
    const idInput = document.querySelector('input[name="id"]');
    if (idInput) idInput.value = v.id;
    const priceEl = document.querySelector('.product-info__price');
    if (priceEl && v.price) {
      priceEl.innerHTML = '<span class="price">' + formatMoney(v.price) + '</span>';
    }
  }

  // Mark sizes that are out of stock in the chosen colour; drop the size if it no longer exists
  function refreshSizes() {
    const color = selectedColor();
    document.querySelectorAll('.size-option').forEach(o => {
      const size = o.textContent.trim();
      const inStock = variants.some(v =>
        (!colorKey || !color || v[colorKey] === color) &&
        [v.option1, v.option2, v.option3].includes(size) && v.available
      );
      o.classList.toggle('sold-out', !inStock);
      if (inStock) o.removeAttribute('aria-disabled'); else o.setAttribute('aria-disabled', 'true');
      if (!inStock && o.classList.contains('selected')) {
        o.classList.remove('selected');
        o.setAttribute('aria-pressed', 'false');
        setOptionDisplay(o.closest('.size-selector'), '');
      }
    });
  }

  // Colour swatch clicks
  document.querySelectorAll('.color-swatch').forEach(swatch => {
    swatch.addEventListener('click', () => {
      document.querySelectorAll('.color-swatch').forEach(s => {
        s.classList.remove('selected');
        s.setAttribute('aria-pressed', 'false');
      });
      swatch.classList.add('selected');
      swatch.setAttribute('aria-pressed', 'true');
      const color = swatch.dataset.color;
      setOptionDisplay(swatch.closest('.color-selector'), color);
      if (colorImages[color]) {
        const mainImg = document.getElementById('product-main-image');
        if (mainImg) { mainImg.src = colorImages[color]; mainImg.srcset = ''; }
      }
      refreshSizes();
      applyVariant(findVariant());
    });
  });

  // Size button clicks
  const sizeOptions = document.querySelectorAll('.size-option');
  sizeOptions.forEach(option => {
    option.addEventListener('click', () => {
      if (option.classList.contains('sold-out')) return;
      sizeOptions.forEach(o => {
        o.classList.remove('selected');
        o.setAttribute('aria-pressed', 'false');
      });
      option.classList.add('selected');
      option.setAttribute('aria-pressed', 'true');
      setOptionDisplay(option.closest('.size-selector'), option.textContent.trim());
      const err = document.querySelector('[data-size-error]');
      if (err) err.hidden = true;
      applyVariant(findVariant());
    });
  });

  if (variants.length) {
    const firstSwatch = document.querySelector('.color-swatch.selected');
    if (firstSwatch) setOptionDisplay(firstSwatch.closest('.color-selector'), firstSwatch.dataset.color);
    refreshSizes();
    applyVariant(findVariant());
  }

  // ============================================================
  // QUANTITY SELECTOR
  // ============================================================
  document.querySelectorAll('.quantity-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.quantity-selector')?.querySelector('.quantity-input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'decrease') val = Math.max(1, val - 1);
      if (btn.dataset.action === 'increase') val = Math.min(99, val + 1);
      input.value = val;
      // The form posts the hidden quantity input, so keep it in step
      const hidden = btn.closest('form')?.querySelector('.quantity-hidden-input');
      if (hidden) hidden.value = val;
    });
  });

  // ============================================================
  // PRODUCT GALLERY THUMBS
  // ============================================================
  const mainImage = document.querySelector('.product-gallery__main img');
  const thumbs = document.querySelectorAll('.gallery__thumb');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImage) {
        mainImage.src = thumb.dataset.src;
        mainImage.srcset = '';
      }
    });
  });

  // ============================================================
  // ACCORDION
  // ============================================================
  document.querySelectorAll('.accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion__item');
      const isOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('.accordion__item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ============================================================
  // SCROLL FADE IN
  // ============================================================
  function initFadeIn(root) {
    const els = (root || document).querySelectorAll('.fade-in:not(.visible)');
    if (!els.length) return;
    if (window.Shopify && Shopify.designMode) {
      els.forEach(el => el.classList.add('visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(el => observer.observe(el));
  }

  initFadeIn();

  document.addEventListener('shopify:section:load', function(e) {
    initFadeIn(e.target);
  });

  // ============================================================
  // NOTIFICATION TOAST
  // ============================================================
  function showNotification(message, duration = 3000) {
    let notif = document.querySelector('.notification');
    if (!notif) {
      notif = document.createElement('div');
      notif.className = 'notification';
      document.body.appendChild(notif);
    }
    notif.textContent = message;
    notif.classList.add('show');
    setTimeout(() => notif.classList.remove('show'), duration);
  }

  window.showNotification = showNotification;

  // ============================================================
  // COLLECTION FILTER TOGGLE
  // ============================================================
  const filterToggle = document.querySelector('.collection-filter-toggle');
  if (filterToggle) {
    const filterPanel = document.getElementById('collection-filters');
    filterToggle.addEventListener('click', () => {
      const isOpen = filterPanel.hidden === false;
      filterPanel.hidden = isOpen;
      filterToggle.setAttribute('aria-expanded', String(!isOpen));
      filterToggle.textContent = isOpen ? 'Filter' : 'Hide filters';
    });
  }

  // ============================================================
  // FORMAT MONEY UTILITY
  // ============================================================
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return `£${amount}`;
  }

  window.formatMoney = formatMoney;

  // ============================================================
  // INIT CART COUNT
  // ============================================================
  (async () => {
    try {
      const r = await fetch('/cart.js');
      const cart = await r.json();
      const countEl = document.querySelector('.cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    } catch (e) {}
  })();

});
